import { createSlice } from '@reduxjs/toolkit'

/**
 * The dashboard series, and whether we actually know it (T-051).
 *
 * Before this the slice held `dashboardData` and nothing else, so the screen
 * could not tell these three apart:
 *
 *   the request has not come back yet           → show a skeleton
 *   the request came back and the shop is quiet → show ৳0
 *   the request FAILED                          → say so, and offer a retry
 *
 * All three rendered as an em dash, which meant a broken dashboard and a slow
 * morning looked identical to the owner. `status` is what separates them.
 */

export const Status = {
    IDLE: 'idle',
    LOADING: 'loading',
    READY: 'ready',
    ERROR: 'error',
}

export const DashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        // Still {} rather than [] so nothing that already reads this changes
        // shape underneath it; dashboardSeries.latestPoint copes with both.
        dashboardData: {},
        status: Status.IDLE,
        error: null,
    },
    reducers: {

        setDashboardData: (state, action) => {
            state.dashboardData = action.payload
            state.status = Status.READY
            state.error = null
        },

        setDashboardLoading: (state) => {
            state.status = Status.LOADING
            // The previous series is deliberately KEPT while the next one
            // loads. Switching from monthly to yearly should not blank the
            // chart it is replacing — that reads as data being lost.
            state.error = null
        },

        setDashboardError: (state, action) => {
            state.status = Status.ERROR
            // Only the serialisable part of the typed error. The classifier
            // attaches `cause`, the original axios error, which is a live
            // object graph and has no business in a redux store.
            state.error = action.payload
        },

    },
})

export const { setDashboardData, setDashboardLoading, setDashboardError } = DashboardSlice.actions

export default DashboardSlice.reducer
